import './global-loader.css';

function GlobalLoader({ isLoading }: { isLoading: boolean }) {
  return isLoading ? (
    <>
      <div className={`global-loader ${isLoading ? 'is-loading' : null}`}>
        <div className="global-loader-fill" />
      </div>
    </>
  ) : null;
}

export default GlobalLoader;
